<template>
  <WdsStack justify-start gap-custom="24px">
    <WdsStack direction-column gap-xs class="tw-pt-2" :class="statusClass">
      <WdsText secondary>
        <WdsStack gap-sm align-center>
          <HireActiveStatusLabel :status="status" data-test-id="hire-page-header-hire-active-status" />
          <WdsTag v-if="engagementTypeLabel" subtle>
            {{ $t(engagementTypeLabel) }}
          </WdsTag>
        </WdsStack>
      </WdsText>
      <WdsStack gap-xs align-center class="tw-pt-1">
        <WdsIcon name="calendar" :size="16" weight="thick" color="#757585" />
        <WdsText secondary>
          <span class="tw-font-medium">{{ start }} - {{ end }}</span>
        </WdsText>
      </WdsStack>
      <slot name="status" />
    </WdsStack>

    <template v-if="company">
      <div
        class="tw-self-stretch tw-bg-gray-100 tw-inline-flex tw-justify-start tw-items-center tw-gap-1.5"
      >
        <div class="tw-w-[1px] tw-self-stretch tw-border-r tw-border-gray-400"></div>
      </div>
      <WdsStack align-center gap-lg class="tw-p-1">
        <WdsAvatarLabel>
          <template #avatar>
            <div class="tw-relative">
              <WdsAvatar :path="getAvatarPath(company.avatar, company.id)" md />
            </div>
          </template>
          <WdsStack direction-column gap-xs justify-start>
            <WdsStack gap-sm justify-start align-center>
              <WdsText :text="company.name ?? ''" large />
              <slot name="company-tags" />
            </WdsStack>
            <slot name="company" />
          </WdsStack>
        </WdsAvatarLabel>
      </WdsStack>
    </template>

    <template v-if="$slots.worker">
      <div
        class="tw-self-stretch tw-bg-gray-100 tw-inline-flex tw-justify-start tw-items-center tw-gap-1.5"
      >
        <div class="tw-w-[1px] tw-self-stretch tw-border-r tw-border-gray-400"></div>
      </div>
      <slot name="worker" />
    </template>
  </WdsStack>
</template>

<script setup lang="ts">
import {
  WdsAvatar,
  WdsAvatarLabel,
  WdsIcon,
  WdsStack,
  WdsTag,
  WdsText,
} from '@worksome/wds-components'
import { HireActiveStatus } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { getAvatarPath } from '@/utils/avatar'
import HireActiveStatusLabel from '@/components/Common/HireActiveStatusLabel.vue'

defineProps<{
  status: HireActiveStatus
  start: string | null
  end: string | null
  engagementTypeLabel?: string | null
  company?: { id: string; name?: string | null; avatar?: string | null } | null
  statusClass?: string | Record<string, boolean>
}>()
</script>
